import clsx from 'clsx'
import {ForwardedRef, forwardRef, HTMLProps} from 'react'
import {DataWithTitleAndBody} from '../../../types'
import Container from '../../atoms/container'
import GridContainer from '../../atoms/grid-container'
import Heading from '../../atoms/heading'
import InfoBox from '../../molecules/info-box'

export interface NextStepsSectionProps
  extends Omit<HTMLProps<HTMLDivElement>, 'ref' | 'cols'> {
  /**
   * List of next steps to be displayed here.
   */
  nextSteps: Array<DataWithTitleAndBody>
  /**
   * Title to be displayed in the section.
   */
  title?: string
  /**
   * Number of columns to be displayed in this section.
   *
   * @default 'md:grid-cols-2 lg:grid-cols-4'
   */
  cols?: string
}

export const NextStepsSection = forwardRef(function NextStepsSection(
  {
    title,
    nextSteps,
    className,
    cols = 'md:grid-cols-2 lg:grid-cols-4',
    ...props
  }: NextStepsSectionProps,
  ref: ForwardedRef<HTMLDivElement>,
) {
  return (
    <section
      className={clsx('bg-highlighted pt-12 pb-16 sm:pb-24 mt-12', className)}
      ref={ref}
      {...props}
    >
      <Container className="grid gap-8 justify-items-center">
        {title && (
          <Heading variant="h2" className="text-center" disableMaxWidth>
            {title}
          </Heading>
        )}

        <GridContainer className={clsx(cols, 'gap-y-8 gap-x-12 w-full')}>
          {nextSteps.map(({title, body}) => (
            <InfoBox title={title} key={title}>
              {body}
            </InfoBox>
          ))}
        </GridContainer>
      </Container>
    </section>
  )
})

export default NextStepsSection
